import { Accordion } from '@mantine/core'
import React from 'react'
import { SPACE, COLOR_INTENT } from 'Theme'

export const VariantAccordion: React.FC<
  React.ComponentProps<typeof Accordion> & { showTopBorder?: boolean }
> = ({ children, showTopBorder, ...rest }) => (
  <Accordion
    chevronPosition="right"
    variant="contained"
    mb={SPACE.PX_10}
    radius={0}
    styles={{
      root: showTopBorder
        ? {
            borderTopStyle: 'solid',
            borderTopWidth: 1,
            borderTopColor: COLOR_INTENT.VARIANT_PICKER.BORDER_COLOR,
          }
        : {},
      item: {
        border: 0,
        backgroundColor: 'transparent',
        borderBottomStyle: 'solid',
        borderBottomWidth: 1,
        borderBottomColor: COLOR_INTENT.VARIANT_PICKER.BORDER_COLOR,
        paddingBottom: 0,
      },
      control: {
        padding: 0,
        paddingTop: SPACE.PX_18,
        paddingBottom: SPACE.PX_18,
        backgroundColor: 'transparent',
      },
      content: {
        padding: 0,
        paddingRight: SPACE.PX_4,
        marginRight: SPACE.PX_4,
        backgroundColor: 'transparent',
        maxHeight: 210,
        overflow: 'auto',
        paddingBottom: SPACE.PX_22,
      },
      label: {
        padding: 0,
      },
    }}
    disableChevronRotation
    chevronSize={SPACE.PX_24}
    {...rest}
  >
    {children}
  </Accordion>
)
